import { Box } from "@mui/material";
import { Message } from "@pages:app/talk/Chat/components/message-view/Message";
import { ChatMessage } from "@pages:app/talk/Chat/components/utils/message";
import { throttle } from "lodash";
import { useCallback, useEffect, useRef } from "react";

interface MessageViewProps {
  messagesTree: ChatMessage[];
}

export const MessageView = ({ messagesTree }: MessageViewProps) => {
  const messageEnd = useRef<HTMLDivElement>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const scrollToRef = useCallback(
    throttle(
      () => messageEnd.current?.scrollIntoView({ behavior: "instant" }),
      500,
      { leading: true },
    ),
    [messageEnd],
  );

  useEffect(() => {
    if (!messagesTree) {
      return;
    }

    scrollToRef();
  }, [messagesTree, scrollToRef]);

  useEffect(() => {
    messageEnd?.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (scrollToRef) {
      scrollToRef();
    }
  }, [scrollToRef]);

  return (
    <Box
      sx={{
        flex: "1 1 0%",
        overflow: "hidden",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: "100%",
        }}
      >
        {messagesTree.map((message) => (
          <Message message={message} key={message.key} />
        ))}
        <Box
          ref={messageEnd}
          sx={{
            paddingY: "2rem",
          }}
        />
      </Box>
    </Box>
  );
};
